module.exports = {
  "projectType": "spa||0.0.0",
  "projectId": "procesoCompra",
  "versionJs": "0.0.1",
  "RECAPTCHA_SITE_KEY_QA": "6LfX050lAAAAAFcmcOy1KdiEi2k5bBrmqWptug1V",
  "RECAPTCHA_SITE_KEY_PROD": "6LekoJ0lAAAAAHv_IXXvHAPqt43_lzzyXf61h0fV",
  "headerInjection": false,
  "footerInjection": false,
  "devPublicPath": "",
  "devCrossOriginLoading": "use-credentials",
  "basePath": "/order/telco/gp",
  "qaPublicPath": "https://dev.ssr.col.movistar.es/order/telco/gp/empleados/",
  "prodPublicPath": "https://prod.cms.col.movistar.es",
  "ssrPublicPath": "https://ssr.col.movistar.es/order/telco/gp/empleados/",
  "qaCrossOriginLoading": false,
  "prodCrossOriginLoading": false,
  "branchName": "manual"
}